import React from 'react';
import { Grid, Header } from 'semantic-ui-react';
import { connect } from 'react-redux';

class YearToDate extends React.Component{
    render(){
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
          });
        return (
            <Grid divided='vertically'>
                <Grid.Row columns={5}>
                    <Grid.Column>
                        <Header sub>Stripe</Header>
                        <Header as="h1">{formatter.format(parseFloat(this.props.stripeCollectionsYtd))}</Header>
                    </Grid.Column>
                    <Grid.Column>
                        <Header sub>Stripe Refunds</Header>
                        <Header as="h1">{formatter.format(parseFloat(this.props.stripeRefundsYtd))}</Header>
                    </Grid.Column>
                    <Grid.Column>
                        <Header sub>PayPal</Header>
                        <Header as="h1">{formatter.format(parseFloat(this.props.payPalCollectionsYtd))}</Header>
                    </Grid.Column>
                    <Grid.Column>
                        <Header sub>PayPal Refunds</Header>
                        <Header as="h1">{formatter.format(parseFloat(this.props.payPalRefundsYtd))}</Header>
                    </Grid.Column>
                    <Grid.Column>
                        <Header sub>YTD Collections</Header>
                        <Header as="h1">{formatter.format(parseFloat(this.props.overallTotal))}</Header>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        )
    }
}

const mapStateToProps = (state) => {
    const dashboard = state.dashboard;
    return {
        payPalCollectionsYtd:     dashboard.payPalCollectionsYtd, 
        payPalRefundsYtd:         dashboard.payPalRefundsYtd, 
        stripeCollectionsYtd:     dashboard.stripeCollectionsYtd, 
        stripeRefundsYtd:         dashboard.stripeRefundsYtd, 
        overallTotal:             dashboard.overallTotal
    };
}

export default connect(mapStateToProps, { })(YearToDate);